export default __webpack_public_path__ + "static/media/pic1.6d28cd3c.jpg";